import Amplify from '@aws-amplify/core'
import config from '../config'

let trackingURL = config.trackingGateway.URL
const {
  location: { hostname },
} = window

if (
  process.env.NODE_ENV === 'development' ||
  hostname.includes('s3-website-us-east-1.amazonaws.com') ||
  hostname.includes('.cloudfront.net')
) {
  trackingURL = config.trackingGateway.DEV_URL
}

export const amplifyConfigData = {
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: 'vc-profile',
      region: config.cognito.REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: 'virtualClinic',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
      },
      {
        name: config.trackingGateway.SERVICE,
        endpoint: trackingURL,
        service: config.trackingGateway.SERVICE,
        region: config.trackingGateway.REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
}

export const amplifyConfigDataNewSetUp = {
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: 'vc-profile',
      region: config.cognito.REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: 'virtualClinic',
        endpoint: config.apiGateway.URL_V2,
        region: config.apiGateway.REGION,
      },
      {
        name: config.trackingGateway.SERVICE,
        endpoint: trackingURL,
        service: config.trackingGateway.SERVICE,
        region: config.trackingGateway.REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
}

export const amplifyConfigEHRData = {
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: 'vc-profile',
      region: config.cognito.REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: 'virtualClinic',
        endpoint: config.apiGateway.URL_EHR,
        region: config.apiGateway.REGION,
      },
      {
        name: config.trackingGateway.SERVICE,
        endpoint: trackingURL,
        service: config.trackingGateway.SERVICE,
        region: config.trackingGateway.REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
}

const amplifyConfigure = () => {
  Amplify.configure(amplifyConfigData)
}

export default amplifyConfigure
